import React from "react";

const TrendToolbar = ({
    period,
    setPeriod,
    metric,
    setMetric,
    chartType,
    setChartType
}) => {

    return (

        <div
            style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 18,
                marginBottom: 20,
                padding: "12px 16px",
                background: "#fff",
                borderRadius: 8,
                border: "1px solid #e5e7eb"
            }}
        >

            {/* Period */}

            <div>

                <span
                    style={{
                        fontWeight: 600,
                        marginRight: 6
                    }}
                >
                    Period
                </span>

                <select
                    value={period}
                    onChange={e =>
                        setPeriod(e.target.value)
                    }
                >

                    <option value="daily">
                        Daily
                    </option>

                    <option value="weekly">
                        Weekly
                    </option>

                    <option value="monthly">
                        Monthly
                    </option>

                </select>

            </div>

            {/* Metric */}

            <div>

                <span
                    style={{
                        fontWeight: 600,
                        marginRight: 6
                    }}
                >
                    Metric
                </span>

                <select
                    value={metric}
                    onChange={e =>
                        setMetric(e.target.value)
                    }
                >

                    <option value="cumulative">
                        Cumulative
                    </option>

                    <option value="daily">
                        Increment
                    </option>

                </select>

            </div>

            {/* Chart */}

            <div>

                <span
                    style={{
                        fontWeight: 600,
                        marginRight: 6
                    }}
                >
                    Chart
                </span>

                <select
                    value={chartType}
                    onChange={e =>
                        setChartType(e.target.value)
                    }
                >

                    <option value="line">
                        Line
                    </option>

                    <option value="bar">
                        Bar
                    </option>

                </select>

            </div>

        </div>

    );

};

export default TrendToolbar;